import { render, staticRenderFns } from "./DaofangShenpi.vue?vue&type=template&id=5abc48cc&scoped=true"
import script from "./DaofangShenpi.vue?vue&type=script&lang=js"
export * from "./DaofangShenpi.vue?vue&type=script&lang=js"
import style0 from "./DaofangShenpi.vue?vue&type=style&index=0&id=5abc48cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc48cc",
  null
  
)

export default component.exports